var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTooltipIcon = function SvgTooltipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 5a7 7 0 1 0 7 7 7.007 7.007 0 0 0-7-7m0 12.833A5.833 5.833 0 1 1 17.833 12 5.84 5.84 0 0 1 12 17.833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 10.833h-.583a.583.583 0 0 0 0 1.167H12v3.5a.583.583 0 0 0 1.167 0V12A1.167 1.167 0 0 0 12 10.833M12 9.667a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75"
  })));
};
export default SvgTooltipIcon;